import { render, staticRenderFns } from "./RenoveExports.vue?vue&type=template&id=10edb28d"
import script from "./RenoveExports.vue?vue&type=script&lang=js"
export * from "./RenoveExports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports